<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-16 14:09:54
 * @LastEditTime: 2026-04-16 14:13:57
 * @LastEditors: ranli
-->
<template>
  <div class="avatar-component" :style="avatarStyle">
    <img v-if="src" :src="src" alt="avatar" class="avatar-image" />
    <img v-else :src="defaultAvatar" alt="default avatar" class="avatar-image" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import defaultAvatar from '@/assets/images/default_avatar-C-UiLCSgW.webp'

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  width: {
    type: [Number, String],
    default: 40,
  },
  height: {
    type: [Number, String],
    default: 40,
  },
})

const avatarStyle = computed(() => {
  const w = typeof props.width === 'number' ? `${props.width}px` : props.width
  const h = typeof props.height === 'number' ? `${props.height}px` : props.height
  return {
    width: w,
    height: h,
  }
})
</script>

<style scoped lang="less">
.avatar-component {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f0f0f0;
  flex-shrink: 0;
  border-radius: 2px;

  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
